import { motion } from "framer-motion";
import { type FC, type PropsWithChildren } from "react";

export const transition = {
	type: "spring",
	mass: 0.35,
	stiffness: 75,
	duration: 0.2,
};

export const animation = {
	index: {
		initial: { x: "-100%" },
		animate: { x: 0 },
		exit: { x: "-100%" },
		transition,
	},
	subpages: {
		initial: { x: "100%" },
		animate: { x: 0 },
		exit: { x: "100%" },
		transition,
	},
};



export type PageTransitionProps = PropsWithChildren<{
	customKey: string;
	index?: boolean;
}>


const pageTransition: FC<PageTransitionProps> = ({ children, customKey, index }) => {
	return (
		<motion.div key={customKey} {...animation[index ? "index" : "subpages"]}>
			{children}
		</motion.div>
	);
};

export default pageTransition;
